import {
  GET_WALKS
} from '../constants/index'
import Api from "../../services/Api"
import WebSocketClient from '../../services/WebSocketClient'

const api = Api.getInstance()
const webSocketClient = WebSocketClient.getInstance();

export const getWalks = (payload: any) => {
  // console.log('walks dispatched', payload)
  if(payload.status === 'ok'){
    return {
      type: GET_WALKS,
      payload
    }
  } else {
    // console.log('error')
  }
}

export const getMyWalks = () => (dispatch: any) => {
  if(api.loggedIn) {
    api.sess_get('my_walks').then(res => {
      dispatch(getWalks(res))
    }).catch((error_status: any) => {
      webSocketClient.sendEvent('session', { 
        type: 'apiError', 
        status: error_status 
      })
    })
  }
}
